import React from "react";
import Layout from "../../layout/builders/Layout";
import PropertyPost from "./PropertyPost";

const HousingPlotPage = () => {
    return (
        <Layout>
            <PropertyPost plotMode="Plots" />
        </Layout>
    );
};

export default HousingPlotPage;
